import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const feedly = defineConnector({
  identifier: "feedly",
  name: "Feedly",
  tagLine: "Threat intelligence feeds",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.feedly\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Feedly account. In the top left, select your workspace name, then under **Workspace**, select **Settings**. Select the **API** tab, then **New API Token**. Name your token and click **Generate API Token**.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.feedly.com/v3/profile",
  },
});
